var map = {
	"./black/baojingqueren2.png": "81ml",
	"./blue/baojingqueren2.png": "SGcm",
	"./white/baojingqueren2.png": "RVYa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "siQM";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/baojingqueren2\.png$
// module id = siQM
// module chunks = 24